const countries = [
    { ru:"Индия",lt:"Indija",tr:"Hindistan", en: 'India',flag: '🇮🇳',code: 'IN', dialCode: '+91', mask: '99999 99999' },
    { ru:"Объединенные Арабские Эмираты",lt:"Jungtiniai Arabų Emyratai",tr:"Birleşik Arap Emirlikleri", en: 'United Arab Emirates',flag: '🇦🇪',code: 'AE', dialCode: '+971', mask: '99 999 9999' },
    { ru:"Германия",lt:"Vokietija",tr:"Almanya", en: 'Germany',flag: '🇩🇪',code: 'DE', dialCode: '+49', mask: '99999 999999' },
    { ru:"Афганистан",lt:"Afganistanas",tr:"Afganistan", en: 'Afghanistan', flag: '🇦🇫', code: 'AF', dialCode: '+93', mask: '999 999 9999' },
    { ru:"Аландские острова",lt:"Alandų salos",tr:"Aland adaları", en: 'Åland Islands', flag: '🇦🇽', code: 'AX', dialCode: '+358', mask: '999 9999999' },
    { ru:"Албания",lt:"Albanija",tr:"Arnavutluk", en: 'Albania',flag: '🇦🇱',code: 'AL', dialCode: '+355', mask: '999 999 9999' },
    { ru:"Алжир",lt:"Alžyras",tr:"Cezayir", en: 'Algeria',flag: '🇩🇿',code: 'DZ', dialCode: '+213', mask: '9999 99 99 99' },
    { ru:"американское Самоа",lt:"Amerikos Samoa",tr:"Amerikan Samoası", en: 'American Samoa',flag: '🇦🇸',code: 'AS', dialCode: '+1684', mask: '(999) 999-9999' },
    { ru:"андорра",lt:"Andora",tr:"Andorra", en: 'Andorra',flag: '🇦🇩',code: 'AD', dialCode: '+376', mask: '999 999' },
    { ru:"Ангола",lt:"Angoloje",tr:"Angora", en: 'Angola',flag: '🇦🇴',code: 'AO', dialCode: '+244', mask: '999 999 999' },
    { ru:"Ангилья",lt:"Angilija",tr:"Anguilla", en: 'Anguilla',flag: '🇦🇮',code: 'AI', dialCode: '+1264', mask: '(999) 999-9999' },
    { ru:"Антигуа и Барбуда",lt:"Antigva ir Barbuda",tr:"Antigua ve Barbuda", en: 'Antigua and Barbuda',flag: '🇦🇬',code: 'AG', dialCode: '+1268', mask: '(999) 999-9999' },
    { ru:"Аргентина",lt:"Argentina",tr:"Arjantin", en: 'Argentina',flag: '🇦🇷',code: 'AR', dialCode: '+54', mask: '999 99-9999-9999' },
    { ru:"Армения",lt:"Armėnija",tr:"Ermenistan", en: 'Armenia',flag: '🇦🇲',code: 'AM', dialCode: '+374', mask: '999 999999' },
    { ru:"Аруба",lt:"Aruba",tr:"Aruba", en: 'Aruba',flag: '🇦🇼',code: 'AW', dialCode: '+297', mask: '999 9999' },
    { ru:"Австралия",lt:"Australija",tr:"Avustralya", en: 'Australia',flag: '🇦🇺',code: 'AU', dialCode: '+61', mask: '999 999 999' },
    { ru:"Австрия",lt:"Austrijoje",tr:"Avusturya", en: 'Austria',flag: '🇦🇹',code: 'AT', dialCode: '+43', mask: '9999 999999' },
    { ru:"Азербайджан",lt:"Azerbaidžanas",tr:"Azerbeycan", en: 'Azerbaijan',flag: '🇦🇿',code: 'AZ', dialCode: '+994', mask: '999 999 99 99' },
    { ru:"Багамские о-ва",lt:"Bahamos",tr:"Bahamalar", en: 'Bahamas',flag: '🇧🇸',code: 'BS', dialCode: '+1242', mask: '(999) 999-999' },
    { ru:"Бахрейн",lt:"Bahreinas",tr:"Bahreyn", en: 'Bahrain',flag: '🇧🇭',code: 'BH', dialCode: '+973', mask: '9999 9999' },
    { ru:"Бангладеш",lt:"Bangladešas",tr:"Bangladeş", en: 'Bangladesh',flag: '🇧🇩',code: 'BD', dialCode: '+880', mask: '99999-99999' },
    { ru:"Барбадос",lt:"Barbadosas",tr:"Barbados", en: 'Barbados',flag: '🇧🇧',code: 'BB', dialCode: '+1246', mask: '(999) 999-9999' },
    { ru:"Беларусь",lt:"Baltarusija",tr:"Belarus", en: 'Belarus',flag: '🇧🇾',code: 'BY', dialCode: '+375', mask: '9 999 999-99-99' },
    { ru:"Бельгия",lt:"Belgija",tr:"Belçika", en: 'Belgium',flag: '🇧🇪',code: 'BE', dialCode: '+32', mask: '999-999-999' },
    { ru:"Белиз",lt:"Belizas",tr:"Belize", en: 'Belize',flag: '🇧🇿',code: 'BZ', dialCode: '+501', mask: '999-9999' },
    { ru:"Бенин",lt:"Beninas",tr:"Benin", en: 'Benin',flag: '🇧🇯',code: 'BJ', dialCode: '+229', mask: '99 99 99 99' },
    { ru:"Бермудские острова",lt:"Bermudai",tr:"Bermuda", en: 'Bermuda',flag: '🇧🇲',code: 'BM', dialCode: '+1441', mask: '(999) 999-9999' },
    { ru:"Бутан",lt:"Butanas",tr:"Butan", en: 'Bhutan',flag: '🇧🇹',code: 'BT', dialCode: '+975', mask: '99 99 99 99' },
    { ru:"Боливия, Многонациональное Государство Боливия",lt:"Bolivija, Bolivijos daugiakalbė valstybė",tr:"Bolivya, Bolivya Çokuluslu Devleti", en: 'Bolivia, Plurinational State of bolivia',flag: '🇧🇴',code: 'BO', dialCode: '+591', mask: '99999999' },
    { ru:"Босния и Герцеговина",lt:"Bosnija ir Hercegovina",tr:"Bosna Hersek", en: 'Bosnia and Herzegovina',flag: '🇧🇦',code: 'BA', dialCode: '+387', mask: '999 999 999' },
    { ru:"Ботсвана",lt:"Botsvana",tr:"Botsvana", en: 'Botswana',flag: '🇧🇼',code: 'BW', dialCode: '+267', mask: '99 999 999' },
    { ru:"Остров Буве",lt:"Bouvet sala",tr:"Bouvet Adası", en: 'Bouvet Island',flag: '🇧🇻',code: 'BV', dialCode: '+47', mask: '(99) 99999-9999' },
    { ru:"Бразилия",lt:"Brazilija",tr:"Brezilya", en: 'Brazil',flag: '🇧🇷',code: 'BR', dialCode: '+55', mask: '(99) 99999 9999' },
    { ru:"Британская территория Индийского океана",lt:"Britanijos Indijos vandenyno teritorija",tr:"Britanya Hint Okyanusu Toprakları", en: 'British Indian Ocean Territory',flag: '🇮🇴',code: 'IO', dialCode: '+246', mask: '(999) 999-9999' },
    { ru:"Бруней-Даруссалам",lt:"Brunėjaus Darusalamas",tr:"Brunei Sultanlığı", en: 'Brunei Darussalam',flag: '🇧🇳',code: 'BN', dialCode: '+673', mask: '999 9999' },
    { ru:"Болгария",lt:"Bulgarija",tr:"Bulgaristan", en: 'Bulgaria',flag: '🇧🇬',code: 'BG', dialCode: '+359', mask: '999 999 999' },
    { ru:"Буркина-Фасо",lt:"Burkina Fasas",tr:"Burkina Faso", en: 'Burkina Faso',flag: '🇧🇫',code: 'BF', dialCode: '+226', mask: '99 99 99 99' },
    { ru:"Бурунди",lt:"Burundis",tr:"Burundi", en: 'Burundi',flag: '🇧🇮',code: 'BI', dialCode: '+257', mask: '99 99 99 99' },
    { ru:"Камбоджа",lt:"Kambodža",tr:"Kamboçya", en: 'Cambodia',flag: '🇰🇭',code: 'KH', dialCode: '+855', mask: '999 999 999' },
    { ru:"Камерун",lt:"Kamerūnas",tr:"Kamerun", en: 'Cameroon',flag: '🇨🇲',code: 'CM', dialCode: '+237', mask: '9 99 99 99 99' },
    { ru:"Канада",lt:"Kanada",tr:"Kanada", en: 'Canada',flag: '🇨🇦',code: 'CA', dialCode: '+1', mask: '(999) 999-9999' },
    { ru:"Кабо-Верде",lt:"Žaliasis Kyšulys",tr:"Yeşil Burun Adaları", en: 'Cape Verde',flag: '🇨🇻',code: 'CV', dialCode: '+238', mask: '999 99 99' },
    { ru:"Каймановы острова",lt:"Kaimanų salos",tr:"Cayman Adaları", en: 'Cayman Islands',flag: '🇰🇾',code: 'KY', dialCode: '+345', mask: '999 9999' },
    { ru:"Центрально-Африканская Республика",lt:"Centrine Afrikos Respublika",tr:"Orta Afrika Cumhuriyeti", en: 'Central African Republic',flag: '🇨🇫',code: 'CF', dialCode: '+236', mask: '99 99 99 99' },
    { ru:"Чад",lt:"Čadas",tr:"Çad", en: 'Chad',flag: '🇹🇩',code: 'TD', dialCode: '+235', mask: '99 99 99 99' },
    { ru:"Чили",lt:"Čilė",tr:"Şili", en: 'Chile',flag: '🇨🇱',code: 'CL', dialCode: '+56', mask: '(9) 9999 9999' },
    { ru:"Китай",lt:"Kinija",tr:"Çin", en: 'China',flag: '🇨🇳',code: 'CN', dialCode: '+86', mask: '999 9999 9999' },
    { ru:"Остров Рождества",lt:"Kalėdų sala",tr:"Noel Adası", en: 'Christmas Island',flag: '🇨🇽',code: 'CX', dialCode: '+61', mask: '9999 999 999' },
    { ru:"Кокосовые (Килинг) острова",lt:"Kokosų (Kylingo) salos",tr:"Cocos (Keeling) Adaları", en: 'Cocos (Keeling) Islands',flag: '🇨🇨',code: 'CC', dialCode: '+61', mask: '9999 999 999' },
    { ru:"Колумбия",lt:"Kolumbija",tr:"Kolombiya", en: 'Colombia',flag: '🇨🇴',code: 'CO', dialCode: '+57', mask: '999 9999999' },
    { ru:"Коморские острова",lt:"Komorai",tr:"Komorlar", en: 'Comoros',flag: '🇰🇲',code: 'KM', dialCode: '+269', mask: '999 99 99' },
    { ru:"Конго",lt:"Kongas",tr:"Kongo", en: 'Congo',flag: '🇨🇬',code: 'CG', dialCode: '+242', mask: '9999 999 999' },
    { ru:"Конго, Демократическая Республика Конго",lt:"Kongo Demokratinė Kongo Respublika",tr:"Kongo, Demokratik Kongo Cumhuriyeti", en: 'Congo, The Democratic Republic of the Congo',flag: '🇨🇩',code: 'CD', dialCode: '+243', mask: '99 999 9999' },
    { ru:"Острова Кука",lt:"Kuko salos",tr:"Cook Adaları", en: 'Cook Islands',flag: '🇨🇰',code: 'CK', dialCode: '+682', mask: '99 999' },
    { ru:"Коста Рика",lt:"Kosta Rika",tr:"Kosta Rika", en: 'Costa Rica',flag: '🇨🇷',code: 'CR', dialCode: '+506', mask: '9999 9999' },
    { ru:"Берег Слоновой Кости",lt:"Dramblio Kaulo Krantas",tr:"Fildişi Sahili", en: "Cote d'Ivoire",flag: '🇨🇮',code: 'CI', dialCode: '+225', mask: '99 99 99 99' },
    { ru:"Хорватия",lt:"Kroatija",tr:"Hırvatistan", en: 'Croatia',flag: '🇭🇷',code: 'HR', dialCode: '+385', mask: '999 999 9999' },
    { ru:"Куба",lt:"Kuba",tr:"Küba", en: 'Cuba',flag: '🇨🇺',code: 'CU', dialCode: '+53', mask: '99 999 999' },
    { ru:"Кипр",lt:"Kipras",tr:"Kıbrıs", en: 'Cyprus',flag: '🇨🇾',code: 'CY', dialCode: '+357', mask: '99 999999' },
    { ru:"Республика Чехия",lt:"Čekijos Respublika",tr:"Çek Cumhuriyeti", en: 'Czech Republic',flag: '🇨🇿',code: 'CZ', dialCode: '+420', mask: '999 999 999' },
    { ru:"Дания",lt:"Danija",tr:"Danimarka", en: 'Denmark',flag: '🇩🇰',code: 'DK', dialCode: '+45', mask: '99 99 99 99' },
    { ru:"Джибути",lt:"Džibutis",tr:"Cibuti", en: 'Djibouti',flag: '🇩🇯',code: 'DJ', dialCode: '+253', mask: '99 99 99 99' },
    { ru:"Доминика",lt:"Dominika",tr:"Dominika", en: 'Dominica',flag: '🇩🇲',code: 'DM', dialCode: '+1767', mask: '(999) 999-9999' },
    { ru:"Эквадор",lt:"Ekvadoras",tr:"Ekvador", en: 'Ecuador',flag: '🇪🇨',code: 'EC', dialCode: '+593', mask: '999 999 9999' },
    { ru:"Египет",lt:"Egiptas",tr:"Mısır", en: 'Egypt',flag: '🇪🇬',code: 'EG', dialCode: '+20', mask: '9999 999 9999' },
    { ru:"Сальвадор",lt:"Salvadoras",tr:"El Salvador", en: 'El Salvador',flag: '🇸🇻',code: 'SV', dialCode: '+503', mask: '9999 9999' },
    { ru:"Экваториальная Гвинея",lt:"Pusiaujo Gvinėja",tr:"Ekvator Ginesi", en: 'Equatorial Guinea',flag: '🇬🇶',code: 'GQ', dialCode: '+240', mask: '999 999 999' },
    { ru:"Эритрея",lt:"Eritrėja",tr:"Eritre", en: 'Eritrea',flag: '🇪🇷',code: 'ER', dialCode: '+291', mask: '99 999 999' },
    { ru:"Эстония",lt:"Estija",tr:"Estonya", en: 'Estonia',flag: '🇪🇪',code: 'EE', dialCode: '+372', mask: '9999 9999' },
    { ru:"Эфиопия",lt:"Etiopija",tr:"Etiyopya", en: 'Ethiopia',flag: '🇪🇹',code: 'ET', dialCode: '+251', mask: '999 999 9999' },
    { ru:"Фолклендские (Мальвинские) острова",lt:"Folklando salos (Malvinai)",tr:"Falkland Adaları (Malvinas)", en: 'Falkland Islands (Malvinas)',flag: '🇫🇰',code: 'FK', dialCode: '+500', mask: '99999' },
    { ru:"Фарерские острова",lt:"Farerų salos",tr:"Faroe Adaları", en: 'Faroe Islands',flag: '🇫🇴',code: 'FO', dialCode: '+298', mask: '999999' },
    { ru:"Фиджи",lt:"Fidžis",tr:"Fiji", en: 'Fiji',flag: '🇫🇯',code: 'FJ', dialCode: '+679', mask: '999 9999' },
    { ru:"Финляндия",lt:"Suomija",tr:"Finlandiya", en: 'Finland',flag: '🇫🇮',code: 'FI', dialCode: '+358', mask: '999 9999999' },
    { ru:"Франция",lt:"Prancūzijoje",tr:"Fransa", en: 'France',flag: '🇫🇷',code: 'FR', dialCode: '+33', mask: '999 999 999' },
    { ru:"Французская Гвиана",lt:"Prancūzijos Gviana",tr:"Fransız Guyanası", en: 'French Guiana',flag: '🇬🇫',code: 'GF', dialCode: '+594', mask: '9999 99 99 99' },
    { ru:"Французская Полинезия",lt:"Prancūzų Polinezija",tr:"Fransız Polinezyası", en: 'French Polynesia',flag: '🇵🇫',code: 'PF', dialCode: '+689', mask: '99 99 99 99' },
    { ru:"Габон",lt:"Gabonas",tr:"Gabon", en: 'Gabon',flag: '🇬🇦',code: 'GA', dialCode: '+241', mask: '99 99 99 99' },
    { ru:"Гамбия",lt:"Gambija",tr:"Gambiya", en: 'Gambia',flag: '🇬🇲',code: 'GM', dialCode: '+220', mask: '999 9999' },
    { ru:"Грузия",lt:"Gruzijoje",tr:"Gürcistan", en: 'Georgia',flag: '🇬🇪',code: 'GE', dialCode: '+995', mask: '999 99 99 99' },
    { ru:"Гана",lt:"Gana",tr:"Gana", en: 'Ghana',flag: '🇬🇭',code: 'GH', dialCode: '+233', mask: '999 999 9999' },
    { ru:"Гибралтар",lt:"Gibraltaras",tr:"Cebelitarık", en: 'Gibraltar',flag: '🇬🇮',code: 'GI', dialCode: '+350', mask: '99999999' },
    { ru:"Греция",lt:"Graikija",tr:"Yunanistan", en: 'Greece',flag: '🇬🇷',code: 'GR', dialCode: '+30', mask: '999 999 9999' },
    { ru:"Гренландия",lt:"Grenlandija",tr:"Grönland", en: 'Greenland',flag: '🇬🇱',code: 'GL', dialCode: '+299', mask: '99 99 99' },
    { ru:"Гренада",lt:"Grenada",tr:"Grenada", en: 'Grenada',flag: '🇬🇩',code: 'GD', dialCode: '+1473', mask: '(999) 999-9999' },
    { ru:"Гваделупа",lt:"Gvadelupa",tr:"Guadeloupe", en: 'Guadeloupe',flag: '🇬🇵',code: 'GP', dialCode: '+590', mask: '9999 99 99 99' },
    { ru:"Гуам",lt:"Guamas",tr:"Guam", en: 'Guam',flag: '🇬🇺',code: 'GU', dialCode: '+1671', mask: '(999) 999-9999' },
    { ru:"Гватемала",lt:"Gvatemala",tr:"Guatemala", en: 'Guatemala',flag: '🇬🇹',code: 'GT', dialCode: '+502', mask: '9999 9999' },
    { ru:"шерстяная фуфайка",lt:"Gernsis",tr:"bir tür inek", en: 'Guernsey',flag: '🇬🇬',code: 'GG', dialCode: '+44', mask: '99999 999999' },
    { ru:"Гвинея",lt:"Gvinėjos",tr:"Gine", en: 'Guinea',flag: '🇬🇳',code: 'GN', dialCode: '+224', mask: '999 99 99 99' },
    { ru:"Гвинея-Бисау",lt:"Bisau Gvinėja",tr:"Gine-Bissau", en: 'Guinea-Bissau',flag: '🇬🇼',code: 'GW', dialCode: '+245', mask: '999 999 999' },
    { ru:"Гайана",lt:"Gajana",tr:"Guyana", en: 'Guyana',flag: '🇬🇾',code: 'GY', dialCode: '+592', mask: '999 9999' },
    { ru:"Гаити",lt:"Haitis",tr:"Haiti", en: 'Haiti',flag: '🇭🇹',code: 'HT', dialCode: '+509', mask: '99 99 9999' },
    { ru:"Гондурас",lt:"Hondūras",tr:"Honduras", en: 'Honduras',flag: '🇭🇳',code: 'HN', dialCode: '+504', mask: '9999-9999' },
    { ru:"Гонконг",lt:"Honkongas",tr:"Hong Kong", en: 'Hong Kong',flag: '🇭🇰',code: 'HK', dialCode: '+852', mask: '9999 9999' },
    { ru:"Венгрия",lt:"Vengrija",tr:"Macaristan", en: 'Hungary',flag: '🇭🇺',code: 'HU', dialCode: '+36', mask: '(99) 999 9999' },
    { ru:"Исландия",lt:"Islandija",tr:"İzlanda", en: 'Iceland',flag: '🇮🇸',code: 'IS', dialCode: '+354', mask: '999 9999' },
    { ru:"Индонезия",lt:"Indonezija",tr:"Endonezya", en: 'Indonesia',flag: '🇮🇩',code: 'ID', dialCode: '+62', mask: '9999-999-999' },
    { ru:"Иран, Исламская Республика Персидского залива",lt:"Iranas, Persijos įlankos Islamo Respublika",tr:"İran, Basra Körfezi İslam Cumhuriyeti", en: 'Iran, Islamic Republic of Persian Gulf',flag: '🇮🇷',code: 'IR', dialCode: '+98', mask: '9999 999 9999' },
    { ru:"Ирак",lt:"Irakas",tr:"Irak", en: 'Iraq',flag: '🇮🇶',code: 'IQ', dialCode: '+964', mask: '9999 999 9999' },
    { ru:"Ирландия",lt:"Airija",tr:"İrlanda", en: 'Ireland',flag: '🇮🇪',code: 'IE', dialCode: '+353', mask: '999 999 9999' },
    { ru:"Остров Мэн",lt:"Meno sala",tr:"Man Adası", en: 'Isle of Man',flag: '🇮🇲',code: 'IM', dialCode: '+44', mask: '99999 999999' },
    { ru:"Израиль",lt:"Izraelis",tr:"İsrail", en: 'Israel',flag: '🇮🇱',code: 'IL', dialCode: '+972', mask: '999-999-9999' },
    { ru:"Италия",lt:"Italijoje",tr:"İtalya", en: 'Italy',flag: '🇮🇹',code: 'IT', dialCode: '+39', mask: '999 999 9999' },
    { ru:"Ямайка",lt:"Jamaika",tr:"Jamaika", en: 'Jamaica',flag: '🇯🇲',code: 'JM', dialCode: '+1876', mask: '(999) 999-9999' },
    { ru:"Япония",lt:"Japonija",tr:"Japonya", en: 'Japan',flag: '🇯🇵',code: 'JP', dialCode: '+81', mask: '99-9999-9999' },
    { ru:"Джерси",lt:"Džersis",tr:"Jersey", en: 'Jersey',flag: '🇯🇪',code: 'JE', dialCode: '+44', mask: '99999 999999' },
    { ru:"Иордания",lt:"Jordanija",tr:"Ürdün", en: 'Jordan',flag: '🇯🇴',code: 'JO', dialCode: '+962', mask: '99 9999 9999' },
    { ru:"Казахстан",lt:"Kazachstanas",tr:"Kazakistan", en: 'Kazakhstan',flag: '🇰🇿',code: 'KZ', dialCode: '+7', mask: '(999) 999 9999' },
    { ru:"Кения",lt:"Kenija",tr:"Kenya", en: 'Kenya',flag: '🇰🇪',code: 'KE', dialCode: '+254', mask: '999 999 9999' },
    { ru:"Кирибати",lt:"Kiribatis",tr:"Kiribati", en: 'Kiribati',flag: '🇰🇮',code: 'KI', dialCode: '+686', mask: '99999999' },
    { ru:"Корея, Корейская Народно-Демократическая Республика",lt:"Korėja, Korėjos Liaudies Demokratinė Respublika",tr:"Kore, Kore Demokratik Halk Cumhuriyeti", en: "Korea, Democratic People's Republic of Korea",flag: '🇰🇵',code: 'KP', dialCode: '+850', mask: '(9) 99999' },
    { ru:"Корея, Республика Южная Корея",lt:"Korėja, Pietų Korėjos Respublika",tr:"Güney Kore Cumhuriyeti", en: 'Korea, Republic of South Korea',flag: '🇰🇷',code: 'KR', dialCode: '+82', mask: '999-9999-9999' },
    { ru:"Косово",lt:"Kosovas",tr:"Kosova", en: 'Kosovo',flag: '🇽🇰',code: 'XK', dialCode: '+383', mask: '999 999 999' },
    { ru:"Кувейт",lt:"Kuveitas",tr:"Kuveyt", en: 'Kuwait',flag: '🇰🇼',code: 'KW', dialCode: '+965', mask: '999 99999' },
    { ru:"Киргизия",lt:"Kirgizija",tr:"Kırgızistan", en: 'Kyrgyzstan',flag: '🇰🇬',code: 'KG', dialCode: '+996', mask: '9999 999 999' },
    { ru:"Лаос",lt:"Laosas",tr:"Laos", en: 'Laos',flag: '🇱🇦',code: 'LA', dialCode: '+856', mask: '999 99 999 999' },
    { ru:"Латвия",lt:"Latvijoje",tr:"Letonya", en: 'Latvia',flag: '🇱🇻',code: 'LV', dialCode: '+371', mask: '99 999 999' },
    { ru:"Ливан",lt:"Libanas",tr:"Lübnan", en: 'Lebanon',flag: '🇱🇧',code: 'LB', dialCode: '+961', mask: '99 999 999' },
    { ru:"Лесото",lt:"Lesotas",tr:"Lesotho", en: 'Lesotho',flag: '🇱🇸',code: 'LS', dialCode: '+266', mask: '9999 9999' },
    { ru:"Либерия",lt:"Liberija",tr:"Liberya", en: 'Liberia',flag: '🇱🇷',code: 'LR', dialCode: '+231', mask: '999 999 9999' },
    { ru:"Ливийская арабская джамахирия",lt:"Libijos arabų Jamahiriya",tr:"Libya Arap Jamahiriya", en: 'Libyan Arab Jamahiriya',flag: '🇱🇾',code: 'LY', dialCode: '+218', mask: '999-9999999' },
    { ru:"Лихтенштейн",lt:"Lichtenšteinas",tr:"Lihtenştayn", en: 'Liechtenstein',flag: '🇱🇮',code: 'LI', dialCode: '+423', mask: '999 999 999' },
    { ru:"Литва",lt:"Lietuva",tr:"Litvanya", en: 'Lithuania',flag: '🇱🇹',code: 'LT', dialCode: '+370', mask: '(9-999) 9999' },
    { ru:"Люксембург",lt:"Liuksemburgas",tr:"Lüksemburg", en: 'Luxembourg',flag: '🇱🇺',code: 'LU', dialCode: '+352', mask: '999 999 999' },
    { ru:"Macao",lt:"Makao",tr:"Macao", en: 'Macao',flag: '🇲🇴',code: 'MO', dialCode: '+853', mask: '9999 9999' },
    { ru:"Македония",lt:"Makedonija",tr:"Makedonya", en: 'Macedonia',flag: '🇲🇰',code: 'MK', dialCode: '+389', mask: '999 999 999' },
    { ru:"Мадагаскар",lt:"Madagaskaras",tr:"Madagaskar", en: 'Madagascar',flag: '🇲🇬',code: 'MG', dialCode: '+261', mask: '999 99 999 99' },
    { ru:"Малави",lt:"Malavis",tr:"Malawi", en: 'Malawi',flag: '🇲🇼',code: 'MW', dialCode: '+265', mask: '9999 99 99 99' },
    { ru:"Малайзия",lt:"Malaizija",tr:"Malezya", en: 'Malaysia',flag: '🇲🇾',code: 'MY', dialCode: '+60', mask: '999-999 9999' },
    { ru:"Мальдивы",lt:"Maldyvai",tr:"Maldivler", en: 'Maldives',flag: '🇲🇻',code: 'MV', dialCode: '+960', mask: '999-9999' },
    { ru:"Мали",lt:"Malis",tr:"Mali", en: 'Mali',flag: '🇲🇱',code: 'ML', dialCode: '+223', mask: '99 99 99 99' },
    { ru:"Мальта",lt:"Malta",tr:"Malta", en: 'Malta',flag: '🇲🇹',code: 'MT', dialCode: '+356', mask: '9999 9999' },
    { ru:"Маршалловы острова",lt:"Maršalo salos",tr:"Marşal Adaları", en: 'Marshall Islands',flag: '🇲🇭',code: 'MH', dialCode: '+692', mask: '999-9999' },
    { ru:"Мартиника",lt:"Martinika",tr:"Martinik", en: 'Martinique',flag: '🇲🇶',code: 'MQ', dialCode: '+596', mask: '9999 99 99 99' },
    { ru:"Мавритания",lt:"Mauritanija",tr:"Moritanya", en: 'Mauritania',flag: '🇲🇷',code: 'MR', dialCode: '+222', mask: '99 99 99 99' },
    { ru:"Маврикий",lt:"Mauricijus",tr:"Mauritius", en: 'Mauritius',flag: '🇲🇺',code: 'MU', dialCode: '+230', mask: '9999 9999' },
    { ru:"Майотта",lt:"Majotas",tr:"Mayotte", en: 'Mayotte',flag: '🇾🇹',code: 'YT', dialCode: '+262', mask: '9999 99 99 99' },
    { ru:"Мексика",lt:"Meksika",tr:"Meksika", en: 'Mexico',flag: '🇲🇽',code: 'MX', dialCode: '+52', mask: '999-999 9999' },
    { ru:"Микронезия, Федеративные Штаты Микронезии",lt:"Mikronezijos Federacinės Mikronezijos valstybės",tr:"Mikronezya, Mikronezya Federal Devletleri", en: 'Micronesia, Federated States of Micronesia',flag: '🇫🇲',code: 'FM', dialCode: '+691', mask: '999 9999' },
    { ru:"Молдова",lt:"Moldovoje",tr:"Moldova", en: 'Moldova',flag: '🇲🇩',code: 'MD', dialCode: '+373', mask: '9999 99 999' },
    { ru:"Монако",lt:"Monakas",tr:"Monako", en: 'Monaco',flag: '🇲🇨',code: 'MC', dialCode: '+377', mask: '99 99 99 99 99' },
    { ru:"Монголия",lt:"Mongolija",tr:"Moğolistan", en: 'Mongolia',flag: '🇲🇳',code: 'MN', dialCode: '+976', mask: '9999 9999' },
    { ru:"Черногория",lt:"Juodkalnija",tr:"Karadağ", en: 'Montenegro',flag: '🇲🇪',code: 'ME', dialCode: '+382', mask: '999 999 999' },
    { ru:"Монсеррат",lt:"Montserratas",tr:"Montserrat", en: 'Montserrat',flag: '🇲🇸',code: 'MS', dialCode: '+1664', mask: '(999) 999-9999' },
    { ru:"Марокко",lt:"Marokas",tr:"Fas", en: 'Morocco',flag: '🇲🇦',code: 'MA', dialCode: '+212', mask: '9999-999999' },
    { ru:"Мозамбик",lt:"Mozambikas",tr:"Mozambik", en: 'Mozambique',flag: '🇲🇿',code: 'MZ', dialCode: '+258', mask: '99 999 9999' },
    { ru:"Мьянма",lt:"Mianmaras",tr:"Myanmar", en: 'Myanmar',flag: '🇲🇲',code: 'MM', dialCode: '+95', mask: '99 999 9999' },
    { ru:"Намибия",lt:"Namibija",tr:"Namibya", en: 'Namibia',flag: '🇳🇦',code: 'NA', dialCode: '+264', mask: '999 999 99999' },
    { ru:"Науру",lt:"Nauru",tr:"Nauru", en: 'Nauru',flag: '🇳🇷',code: 'NR', dialCode: '+674', mask: '999 9999' },
    { ru:"Непал",lt:"Nepalas",tr:"Nepal", en: 'Nepal',flag: '🇳🇵',code: 'NP', dialCode: '+977', mask: '999-9999999' },
    { ru:"Нидерланды",lt:"Nyderlandai",tr:"Hollanda", en: 'Netherlands',flag: '🇳🇱',code: 'NL', dialCode: '+31', mask: '99 99999999' },
    { ru:"Новая Каледония",lt:"Naujoji Kaledonija",tr:"Yeni Kaledonya", en: 'New Caledonia',flag: '🇳🇨',code: 'NC', dialCode: '+687', mask: '99.99.99' },
    { ru:"Новая Зеландия",lt:"Naujoji Zelandija",tr:"Yeni Zelanda", en: 'New Zealand',flag: '🇳🇿',code: 'NZ', dialCode: '+64', mask: '999 999 9999' },
    { ru:"Никарагуа",lt:"Nikaragva",tr:"Nikaragua", en: 'Nicaragua',flag: '🇳🇮',code: 'NI', dialCode: '+505', mask: '9999 9999' },
    { ru:"Нигер",lt:"Nigeris",tr:"Nijer", en: 'Niger',flag: '🇳🇪',code: 'NE', dialCode: '+227', mask: '99 99 99 99' },
    { ru:"Нигерия",lt:"Nigerija",tr:"Nijerya", en: 'Nigeria',flag: '🇳🇬',code: 'NG', dialCode: '+234', mask: '9999 999 9999' },
    { ru:"Niue",lt:"Niue",tr:"Niue", en: 'Niue',flag: '🇳🇺',code: 'NU', dialCode: '+683', mask: '999 9999' },
    { ru:"Остров Норфолк",lt:"Norfolko sala",tr:"Norfolk Adası", en: 'Norfolk Island',flag: '🇳🇫',code: 'NF', dialCode: '+672', mask: '9 99999' },
    { ru:"Северные Марианские острова",lt:"Šiaurinės Marianos salos",tr:"Kuzey Mariana Adaları", en: 'Northern Mariana Islands',flag: '🇲🇵',code: 'MP', dialCode: '+1670', mask: '(999) 999-9999' },
    { ru:"Норвегия",lt:"Norvegija",tr:"Norveç", en: 'Norway',flag: '🇳🇴',code: 'NO', dialCode: '+47', mask: '999 99 999' },
    { ru:"Оман",lt:"Omanas",tr:"Umman", en: 'Oman',flag: '🇴🇲',code: 'OM', dialCode: '+968', mask: '9999 9999' },
    { ru:"Пакистан",lt:"Pakistanas",tr:"Pakistan", en: 'Pakistan',flag: '🇵🇰',code: 'PK', dialCode: '+92', mask: '9999 999999' },
    { ru:"Palau",lt:"Palau",tr:"Palau", en: 'Palau',flag: '🇵🇼',code: 'PW', dialCode: '+680', mask: '999 9999' },
    { ru:"Палестинская территория, оккупированная",lt:"Palestinos teritorija, okupuota",tr:"Filistin Arazisi, İşgal altında", en: 'Palestinian Territory, Occupied',flag: '🇵🇸',code: 'PS', dialCode: '+970', mask: '9999 999 999' },
    { ru:"Панама",lt:"Panama",tr:"Panama", en: 'Panama',flag: '🇵🇦',code: 'PA', dialCode: '+507', mask: '9999-9999' },
    { ru:"Папуа - Новая Гвинея",lt:"Papua Naujoji Gvinėja",tr:"Papua Yeni Gine", en: 'Papua New Guinea',flag: '🇵🇬',code: 'PG', dialCode: '+675', mask: '9999 9999' },
    { ru:"Парагвай",lt:"Paragvajus",tr:"Paraguay", en: 'Paraguay',flag: '🇵🇾',code: 'PY', dialCode: '+595', mask: '9999 999999' },
    { ru:"Перу",lt:"Peru",tr:"Peru", en: 'Peru',flag: '🇵🇪',code: 'PE', dialCode: '+51', mask: '999 999 999' },
    { ru:"Филиппины",lt:"Filipinai",tr:"Filipinler", en: 'Philippines',flag: '🇵🇭',code: 'PH', dialCode: '+63', mask: '9999 999 9999' },
    { ru:"Польша",lt:"Lenkija",tr:"Polonya", en: 'Poland',flag: '🇵🇱',code: 'PL', dialCode: '+48', mask: '999 999 999' },
    { ru:"Португалия",lt:"Portugalija",tr:"Portekiz", en: 'Portugal',flag: '🇵🇹',code: 'PT', dialCode: '+351', mask: '999 999 999' },
    { ru:"Пуэрто-Рико",lt:"Puerto Rikas",tr:"Porto Riko", en: 'Puerto Rico',flag: '🇵🇷',code: 'PR', dialCode: '+1939', mask: '(999) 999-9999' },
    { ru:"Катар",lt:"Kataras",tr:"Katar", en: 'Qatar',flag: '🇶🇦',code: 'QA', dialCode: '+974', mask: '9999 9999' },
    { ru:"Румыния",lt:"Rumunija",tr:"Romanya", en: 'Romania',flag: '🇷🇴',code: 'RO', dialCode: '+40', mask: '9999 999 999' },
    { ru:"Россия",lt:"Rusija",tr:"Rusya", en: 'Russia',flag: '🇷🇺',code: 'RU', dialCode: '+7', mask: '(999) 999-99-99' },
    { ru:"Руанда",lt:"Ruanda",tr:"Ruanda", en: 'Rwanda',flag: '🇷🇼',code: 'RW', dialCode: '+250', mask: '9999 999 999' },
    { ru:"Сен-Бартельми",lt:"Šventasis Barthelemy",tr:"Saint Barthelemy", en: 'Saint Barthelemy',flag: '🇧🇱',code: 'BL', dialCode: '+590', mask: '9999 99 99 99' },
    { ru:"Святой Елены, Вознесения и Тристан-да-Кунья",lt:"Šventoji Helena, Ascension ir Tristan Da Cunha",tr:"Saint Helena, Yükseliş ve Tristan Da Cunha", en: 'Saint Helena, Ascension and Tristan Da Cunha',flag: '🇸🇭',code: 'SH', dialCode: '+290', mask: '99999' },
    { ru:"Сент-Китс и Невис",lt:"Sent Kitsas ir Nevis",tr:"Saint Kitts ve Nevis", en: 'Saint Kitts and Nevis',flag: '🇰🇳',code: 'KN', dialCode: '+1869', mask: '(999) 999-9999' },
    { ru:"Сент-Люсия",lt:"Sent Lusija",tr:"Saint Lucia", en: 'Saint Lucia',flag: '🇱🇨',code: 'LC', dialCode: '+1758', mask: '(999) 999-9999' },
    { ru:"Святой мартин",lt:"Sent Martinas",tr:"Aziz Martin", en: 'Saint Martin',flag: '🇲🇫',code: 'MF', dialCode: '+590', mask: '9999 99 99 99' },
    { ru:"Сен-Пьер и Микелон",lt:"Sent Pjeras ir Mikelonas",tr:"Saint Pierre ve Miquelon", en: 'Saint Pierre and Miquelon',flag: '🇵🇲',code: 'PM', dialCode: '+508', mask: '999 99 99' },
    { ru:"Святой Винсент и Гренадины",lt:"Sent Vinsentas ir Grenadinai",tr:"Saint Vincent ve Grenadinler", en: 'Saint Vincent and the Grenadines',flag: '🇻🇨',code: 'VC', dialCode: '+1784', mask: '(999) 999-9999' },
    { ru:"Самоа",lt:"Samoa",tr:"Samoa", en: 'Samoa',flag: '🇼🇸',code: 'WS', dialCode: '+685', mask: '99 99999' },
    { ru:"Сан-Марино",lt:"San Marinas",tr:"San Marino", en: 'San Marino',flag: '🇸🇲',code: 'SM', dialCode: '+378', mask: '99 99 99 99' },
    { ru:"Сан-Томе и Принсипи",lt:"San Tomė ir Principe",tr:"Sao Tome ve Principe", en: 'Sao Tome and Principe',flag: '🇸🇹',code: 'ST', dialCode: '+239', mask: '999 9999' },
    { ru:"Саудовская Аравия",lt:"Saudo Arabija",tr:"Suudi Arabistan", en: 'Saudi Arabia',flag: '🇸🇦',code: 'SA', dialCode: '+966', mask: '999 999 999' },
    { ru:"Сенегал",lt:"Senegalas",tr:"Senegal", en: 'Senegal',flag: '🇸🇳',code: 'SN', dialCode: '+221', mask: '99 999 99 99' },
    { ru:"Сербия",lt:"Serbija",tr:"Sırbistan", en: 'Serbia',flag: '🇷🇸',code: 'RS', dialCode: '+381', mask: '999 9999999' },
    { ru:"Сейшельские острова",lt:"Seišeliai",tr:"Seyşeller", en: 'Seychelles',flag: '🇸🇨',code: 'SC', dialCode: '+248', mask: '9 999 999' },
    { ru:"Сьерра-Леоне",lt:"Siera Leonė",tr:"Sierra Leone", en: 'Sierra Leone',flag: '🇸🇱',code: 'SL', dialCode: '+232', mask: '(999) 999999' },
    { ru:"Сингапур",lt:"Singapūras",tr:"Singapur", en: 'Singapore',flag: '🇸🇬',code: 'SG', dialCode: '+65', mask: '9999 9999' },
    { ru:"Словакия",lt:"Slovakija",tr:"Slovakya", en: 'Slovakia',flag: '🇸🇰',code: 'SK', dialCode: '+421', mask: '9999 999 999' },
    { ru:"Словения",lt:"Slovėnija",tr:"Slovenya", en: 'Slovenia',flag: '🇸🇮',code: 'SI', dialCode: '+386', mask: '999 999 999' },
    { ru:"Соломоновы острова",lt:"Saliamono salos",tr:"Solomon Adaları", en: 'Solomon Islands',flag: '🇸🇧',code: 'SB', dialCode: '+677', mask: '99 99999' },
    { ru:"Сомали",lt:"Somalis",tr:"Somali", en: 'Somalia',flag: '🇸🇴',code: 'SO', dialCode: '+252', mask: '9 9999999' },
    { ru:"Южная Африка",lt:"pietų Afrika",tr:"Güney Afrika", en: 'South Africa',flag: '🇿🇦',code: 'ZA', dialCode: '+27', mask: '99 999 9999' },
    { ru:"южный Судан",lt:"Pietų Sudanas",tr:"Güney Sudan", en: 'South Sudan',flag: '🇸🇸',code: 'SS', dialCode: '+211', mask: '9999 999 999' },
    { ru:"Испания",lt:"Ispanija",tr:"ispanya", en: 'Spain',flag: '🇪🇸',code: 'ES', dialCode: '+34', mask: '999 99 99 99' },
    { ru:"Шри-Ланка",lt:"Šri Lanka",tr:"Sri Lanka", en: 'Sri Lanka',flag: '🇱🇰',code: 'LK', dialCode: '+94', mask: '999 999 9999' },
    { ru:"Судан",lt:"Sudanas",tr:"Sudan", en: 'Sudan',flag: '🇸🇩',code: 'SD', dialCode: '+249', mask: '999 999 9999' },
    { ru:"Суринам",lt:"Surinamas",tr:"Surinam", en: 'Suriname',flag: '🇸🇷',code: 'SR', dialCode: '+597', mask: '999-9999' },
    { ru:"Шпицберген и Ян Майен",lt:"Svalbardas ir Janas Mayenas",tr:"Svalbard ve Jan Mayen", en: 'Svalbard and Jan Mayen',flag: '🇸🇯',code: 'SJ', dialCode: '+47', mask: '999 99 999' },
    { ru:"Свазиленд",lt:"Svazilandas",tr:"Svaziland", en: 'Swaziland',flag: '🇸🇿',code: 'SZ', dialCode: '+268', mask: '9999 9999' },
    { ru:"Швеция",lt:"Švedija",tr:"İsveç", en: 'Sweden',flag: '🇸🇪',code: 'SE', dialCode: '+46', mask: '999-999 99 99' },
    { ru:"Швейцария",lt:"Šveicarija",tr:"İsviçre", en: 'Switzerland',flag: '🇨🇭',code: 'CH', dialCode: '+41', mask: '99 999 9999' },
    { ru:"Сирийская Арабская Республика",lt:"Sirijos Arabų Respublika",tr:"Suriye Arap Cumhuriyeti", en: 'Syrian Arab Republic',flag: '🇸🇾',code: 'SY', dialCode: '+963', mask: '9999 999 999' },
    { ru:"Тайвань",lt:"Taivanas",tr:"Tayvan", en: 'Taiwan',flag: '🇹🇼',code: 'TW', dialCode: '+886', mask: '9999 999 999' },
    { ru:"Таджикистан",lt:"Tadžikistanas",tr:"Tacikistan", en: 'Tajikistan',flag: '🇹🇯',code: 'TJ', dialCode: '+992', mask: '999 99 9999' },
    { ru:"Танзания, Объединенная Республика Танзания",lt:"Tanzanija, Jungtinė Tanzanijos Respublika",tr:"Tanzanya, Tanzanya Birleşik Cumhuriyeti", en: 'Tanzania, United Republic of Tanzania',flag: '🇹🇿',code: 'TZ', dialCode: '+255', mask: '9999 999 999' },
    { ru:"Таиланд",lt:"Tailandas",tr:"Tayland", en: 'Thailand',flag: '🇹🇭',code: 'TH', dialCode: '+66', mask: '999 999 9999' },
    { ru:"Восточный Тимор",lt:"Timoras-Leste",tr:"Timor-Leste", en: 'Timor-Leste',flag: '🇹🇱',code: 'TL', dialCode: '+670', mask: '9999 9999' },
    { ru:"Идти",lt:"Eiti",tr:"Gitmek", en: 'Togo',flag: '🇹🇬',code: 'TG', dialCode: '+228', mask: '99 99 99 99' },
    { ru:"Токелау",lt:"Tokelau",tr:"Tokelau", en: 'Tokelau',flag: '🇹🇰',code: 'TK', dialCode: '+690', mask: '9999' },
    { ru:"Тонга",lt:"Tonga",tr:"Tonga", en: 'Tonga',flag: '🇹🇴',code: 'TO', dialCode: '+676', mask: '999 9999' },
    { ru:"Тринидад и Тобаго",lt:"Trinidadas ir Tobagas",tr:"Trinidad ve Tobago", en: 'Trinidad and Tobago',flag: '🇹🇹',code: 'TT', dialCode: '+1868', mask: '(999) 999-9999' },
    { ru:"Тунис",lt:"Tunisas",tr:"Tunus", en: 'Tunisia',flag: '🇹🇳',code: 'TN', dialCode: '+216', mask: '99 999 999' },
    { ru:"индейка",lt:"Turkija",tr:"Türkiye", en: 'Turkey',flag: '🇹🇷',code: 'TR', dialCode: '+90', mask: '(999) 999 9999' },
    { ru:"Туркменистан",lt:"Turkmėnistanas",tr:"Türkmenistan", en: 'Turkmenistan',flag: '🇹🇲',code: 'TM', dialCode: '+993', mask: '9 99 999999' },
    { ru:"Острова Теркс и Кайкос",lt:"Terkso ir Kaikoso salos",tr:"Turks ve Caicos Adaları", en: 'Turks and Caicos Islands',flag: '🇹🇨',code: 'TC', dialCode: '+1649', mask: '(999) 999-9999' },
    { ru:"Тувалу",lt:"Tuvalu",tr:"Tuvalu", en: 'Tuvalu',flag: '🇹🇻',code: 'TV', dialCode: '+688', mask: '999999' },
    { ru:"Уганда",lt:"Uganda",tr:"Uganda", en: 'Uganda',flag: '🇺🇬',code: 'UG', dialCode: '+256', mask: '9999 999999' },
    { ru:"Украина",lt:"Ukraina",tr:"Ukrayna", en: 'Ukraine',flag: '🇺🇦',code: 'UA', dialCode: '+380', mask: '999 999 999' },
    { ru:"объединенное Королевство",lt:"Jungtinė Karalystė",tr:"Birleşik Krallık", en: 'United Kingdom',flag: '🇬🇧',code: 'GB', dialCode: '+44', mask: '9999 999999' },
    { ru:"Соединенные Штаты",lt:"Jungtinės Valstijos",tr:"Amerika Birleşik Devletleri", en: 'United States',flag: '🇺🇸',code: 'US', dialCode: '+1', mask: '(999) 999-9999' },
    { ru:"Уругвай",lt:"Urugvajus",tr:"Uruguay", en: 'Uruguay',flag: '🇺🇾',code: 'UY', dialCode: '+598', mask: '99 999 999' },
    { ru:"Узбекистан",lt:"Uzbekistanas",tr:"Özbekistan", en: 'Uzbekistan',flag: '🇺🇿',code: 'UZ', dialCode: '+998', mask: '9 99 999 99 99' },
    { ru:"Вануату",lt:"Vanuatu",tr:"Vanuatu", en: 'Vanuatu',flag: '🇻🇺',code: 'VU', dialCode: '+678', mask: '999 9999' },
    { ru:"Венесуэла, Боливарианская Республика Венесуэла",lt:"Venesuela, Venesuelos Bolivaro Respublika",tr:"Venezuela, Bolivarcı Venezuela Cumhuriyeti", en: 'Venezuela, Bolivarian Republic of Venezuela',flag: '🇻🇪',code: 'VE', dialCode: '+58', mask: '9999-9999999' },
    { ru:"Вьетнам",lt:"Vietnamas",tr:"Vietnam", en: 'Vietnam',flag: '🇻🇳',code: 'VN', dialCode: '+84', mask: '999 999 99 99' },
    { ru:"Уоллис и Футуна",lt:"Volis ir Futuna",tr:"Wallis ve Futuna", en: 'Wallis and Futuna',flag: '🇼🇫',code: 'WF', dialCode: '+681', mask: '99 99 99' },
    { ru:"Йемен",lt:"Jemenas",tr:"Yemen", en: 'Yemen',flag: '🇾🇪',code: 'YE', dialCode: '+967', mask: '999 999 999' },
    { ru:"Замбия",lt:"Zambija",tr:"Zambiya", en: 'Zambia',flag: '🇿🇲',code: 'ZM', dialCode: '+260', mask: '999 9999999' },
    { ru:"Zimbabve",lt:"Zimbabvė",tr:"Zimbabve", en: 'Zimbabwe',flag: '🇿🇼',code: 'ZW', dialCode: '+263', mask: '999 999 9999' }
  ];
const CountriesLength = [
	{
		alpha2: 'US',
		alpha3: 'USA',
		country_code: '1',
		country_name: 'United States',
		mobile_begin_with: ['201', '202', '203', '205', '206', '207', '208', '209', '210', '212', '213', '214', '215',
			'216', '217', '218', '219', '220', '223', '224', '225', '227', '228', '229', '231', '234', '239', '240',
			'248', '251', '252', '253', '254', '256', '260', '262', '267', '269', '270', '272', '274', '276', '278',
			'281', '283', '301', '302', '303', '304', '305', '307', '308', '309', '310', '312', '313', '314', '315',
			'316', '317', '318', '319', '320', '321', '323', '325', '327', '330', '331', '332', '334', '336', '337',
			'339', '341', '346', '347', '351', '352', '360', '361', '364', '369', '380', '385', '386', '401', '402',
			'404', '405', '406', '407', '408', '409', '410', '412', '413', '414', '415', '417', '419', '423', '424',
			'425', '430', '432', '434', '435', '440', '441', '442', '443', '445', '447', '458', '463', '464', '469', '470', '475',
			'478', '479', '480', '484', '501', '502', '503', '504', '505', '507', '508', '509', '510', '512', '513',
			'515', '516', '517', '518', '520', '530', '531', '534', '539', '540', '541', '551', '557', '559', '561',
			'562', '563', '564', '567', '570', '571', '572', '573', '574', '575', '580', '582', '585', '586', '601', '602',
			'603', '605', '606', '607', '608', '609', '610', '612', '614', '615', '616', '617', '618', '619', '620',
			'623', '626', '627', '628', '629', '630', '631', '636', '640', '641', '646', '650', '651', '656', '657', '659', '660',
			'661', '662', '667', '669', '678', '679', '680', '681', '682', '689', '701', '702', '703', '704', '706', '707',
			'708', '712', '713', '714', '715', '716', '717', '718', '719', '720', '724', '725', '726', '727', '730', '731',
			'732', '734', '737', '740', '743', '747', '752', '754', '757', '760', '762', '763', '764', '765', '769', '770', '771',
			'772', '773', '774', '775', '779', '781', '785', '786', '787', '801', '802', '803', '804', '805', '806', '808',
			'810', '812', '813', '814', '815', '816', '817', '818', '820', '828', '830', '831', '832', '835', '838', '840', '843', '845',
			'847', '848', '850', '854', '856', '857', '858', '859', '860', '862', '863', '864', '865', '870', '872',
			'878', '901', '903', '904', '906', '907', '908', '909', '910', '912', '913', '914', '915', '916', '917',
			'918', '919', '920', '925', '927', '928', '929', '930', '931', '934', '935', '936', '937', '938', '939', '940', '941', '945',
			'947', '949', '951', '952', '954', '956', '957', '959', '970', '971', '972', '973', '975', '978', '979',
			'980', '984', '985', '986', '989', '888', '800', '833', '844', '855', '866', '877', '279', '340', '983', '448', '943', '363',
			'326', '839', '826', '948'
		],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'AW',
		alpha3: 'ABW',
		country_code: '297',
		country_name: 'Aruba',
		mobile_begin_with: ['5', '6', '7', '9'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'AF',
		alpha3: 'AFG',
		country_code: '93',
		country_name: 'Afghanistan',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'AO',
		alpha3: 'AGO',
		country_code: '244',
		country_name: 'Angola',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'AI',
		alpha3: 'AIA',
		country_code: '1',
		country_name: 'Anguilla',
		mobile_begin_with: ['2642', '2644', '2645', '2647'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'AX',
		alpha3: 'ALA',
		country_code: '358',
		country_name: 'Åland Islands',
		mobile_begin_with: ['18'],
		phone_number_lengths: [6, 7, 8]
	},
	{
		alpha2: 'AL',
		alpha3: 'ALB',
		country_code: '355',
		country_name: 'Albania',
		mobile_begin_with: ['6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'AD',
		alpha3: 'AND',
		country_code: '376',
		country_name: 'Andorra',
		mobile_begin_with: ['3', '4', '6'],
		phone_number_lengths: [6]
	},
	// {alpha2: "AN", alpha3: "ANT", country_code: "599", country_name: "Netherlands Antilles", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'AE',
		alpha3: 'ARE',
		country_code: '971',
		country_name: 'United Arab Emirates',
		mobile_begin_with: ['5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'AR',
		alpha3: 'ARG',
		country_code: '54',
		country_name: 'Argentina',
		mobile_begin_with: ['1', '2', '3'], // Same for mobile and landlines
		phone_number_lengths: [8, 9, 10, 11, 12]
	},
	{
		alpha2: 'AM',
		alpha3: 'ARM',
		country_code: '374',
		country_name: 'Armenia',
		mobile_begin_with: ['3', '4', '5', '7', '9'],
		phone_number_lengths: [8]
	},
	// http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=american_samoa
	{
		alpha2: 'AS',
		alpha3: 'ASM',
		country_code: '1',
		country_name: 'American Samoa',
		mobile_begin_with: ['684733', '684258'],
		phone_number_lengths: [10]
	},
	// {alpha2: "AQ", alpha3: "ATA", country_code: "672", country_name: "Antarctica", mobile_begin_with: [], phone_number_lengths: []},
	// {alpha2: "TF", alpha3: "ATF", country_code: "", country_name: "French Southern Territories", mobile_begin_with: [], phone_number_lengths: []},
	// http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=antigua_barbuda
	{
		alpha2: 'AG',
		alpha3: 'ATG',
		country_code: '1',
		country_name: 'Antigua and Barbuda',
		mobile_begin_with: ['2687'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'AU',
		alpha3: 'AUS',
		country_code: '61',
		country_name: 'Australia',
		mobile_begin_with: ['4'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'AT',
		alpha3: 'AUT',
		country_code: '43',
		country_name: 'Austria',
		mobile_begin_with: ['6'],
		phone_number_lengths: [10, 11, 12, 13, 14]
	},
	{
		alpha2: 'AZ',
		alpha3: 'AZE',
		country_code: '994',
		country_name: 'Azerbaijan',
		mobile_begin_with: ['10', '50', '51', '55', '60', '70', '77', '99'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'BI',
		alpha3: 'BDI',
		country_code: '257',
		country_name: 'Burundi',
		mobile_begin_with: ['7', '29'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'BE',
		alpha3: 'BEL',
		country_code: '32',
		country_name: 'Belgium',
		mobile_begin_with: ['4', '3'],
		phone_number_lengths: [9, 8]
	},
	{
		alpha2: 'BJ',
		alpha3: 'BEN',
		country_code: '229',
		country_name: 'Benin',
		mobile_begin_with: ['4', '6', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'BF',
		alpha3: 'BFA',
		country_code: '226',
		country_name: 'Burkina Faso',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'BD',
		alpha3: 'BGD',
		country_code: '880',
		country_name: 'Bangladesh',
		mobile_begin_with: ['1'],
		phone_number_lengths: [8, 9, 10]
	},
	{
		alpha2: 'BG',
		alpha3: 'BGR',
		country_code: '359',
		country_name: 'Bulgaria',
		mobile_begin_with: ['87', '88', '89', '98', '99', '43'],
		phone_number_lengths: [8, 9]
	},
	{
		alpha2: 'BH',
		alpha3: 'BHR',
		country_code: '973',
		country_name: 'Bahrain',
		mobile_begin_with: ['3'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'BS',
		alpha3: 'BHS',
		country_code: '1',
		country_name: 'Bahamas',
		mobile_begin_with: ['242'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'BA',
		alpha3: 'BIH',
		country_code: '387',
		country_name: 'Bosnia and Herzegovina',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	// {alpha2: "BL", alpha3: "BLM", country_code: "590", country_name: "Saint Barthélemy", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'BY',
		alpha3: 'BLR',
		country_code: '375',
		country_name: 'Belarus',
		mobile_begin_with: ['25', '29', '33', '44'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'BZ',
		alpha3: 'BLZ',
		country_code: '501',
		country_name: 'Belize',
		mobile_begin_with: ['6'],
		phone_number_lengths: [7]
	},
	// http://www.howtocallabroad.com/results.php?callfrom=united_states&callto=bermuda
	{
		alpha2: 'BM',
		alpha3: 'BMU',
		country_code: '1',
		country_name: 'Bermuda',
		mobile_begin_with: ['4413', '4415', '4417'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'BO',
		alpha3: 'BOL',
		country_code: '591',
		country_name: 'Bolivia',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'BR',
		alpha3: 'BRA',
		country_code: '55',
		country_name: 'Brazil',
		mobile_begin_with: [
			'119', '129', '139', '149', '159', '169', '179', '189', '199', '219', '229', '249', '279', '289',
			'319', '329', '339', '349', '359', '379', '389',
			'419', '429', '439', '449', '459', '469', '479', '489', '499',
			'519', '539', '549', '559',
			'619', '629', '639', '649', '659', '669', '679', '689', '699',
			'719', '739', '749', '759', '779', '799',
			'819', '829', '839', '849', '859', '869', '879', '889', '899',
			'919', '929', '939', '949', '959', '969', '979', '989', '999',
		],
		phone_number_lengths: [10, 11]
	},
	{
		alpha2: 'BB',
		alpha3: 'BRB',
		country_code: '1',
		country_name: 'Barbados',
		mobile_begin_with: ['246'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'BN',
		alpha3: 'BRN',
		country_code: '673',
		country_name: 'Brunei Darussalam',
		mobile_begin_with: ['7', '8'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'BT',
		alpha3: 'BTN',
		country_code: '975',
		country_name: 'Bhutan',
		mobile_begin_with: ['17'],
		phone_number_lengths: [8]
	},
	// {alpha2: "BV", alpha3: "BVT", country_code: "", country_name: "Bouvet Island", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'BW',
		alpha3: 'BWA',
		country_code: '267',
		country_name: 'Botswana',
		mobile_begin_with: ['71', '72', '73', '74', '75', '76', '77', '78', '79'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'CF',
		alpha3: 'CAF',
		country_code: '236',
		country_name: 'Central African Republic',
		mobile_begin_with: ['7'],
		phone_number_lengths: [8]
	},

	// http://www.howtocallabroad.com/canada/
	// http://areacode.org/
	// http://countrycode.org/canada
	{
		alpha2: 'CA',
		alpha3: 'CAN',
		country_code: '1',
		country_name: 'Canada',
		mobile_begin_with: [
			'204', '226', '236', '249', '250', '263', '289', '306', '343', '354',
			'365', '367', '368', '403', '416', '418', '431', '437', '438', '450',
			'468', '474', '506', '514', '519', '548', '579', '581', '584', '587',
			'600', '604', '613', '639', '647', '672', '683', '705', '709', '742',
			'753', '778', '780', '782', '807', '819', '825', '867', '873', '902',
			'905', '428', '382'],
		phone_number_lengths: [10]
	},
	// {alpha2: "CC", alpha3: "CCK", country_code: "61", country_name: "Cocos (Keeling) Islands", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'CH',
		alpha3: 'CHE',
		country_code: '41',
		country_name: 'Switzerland',
		mobile_begin_with: ['74', '75', '76', '77', '78', '79'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'CL',
		alpha3: 'CHL',
		country_code: '56',
		country_name: 'Chile',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'CN',
		alpha3: 'CHN',
		country_code: '86',
		country_name: 'China',
		mobile_begin_with: ['13', '14', '15', '17', '18', '19', '16'],
		phone_number_lengths: [11]
	},
	{
		alpha2: 'CI',
		alpha3: 'CIV',
		country_code: '225',
		country_name: "Côte D'Ivoire",
		mobile_begin_with: ['0', '4', '5', '6', '7', '8'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'CM',
		alpha3: 'CMR',
		country_code: '237',
		country_name: 'Cameroon',
		mobile_begin_with: ['6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'CD',
		alpha3: 'COD',
		country_code: '243',
		country_name: 'Congo, The Democratic Republic Of The',
		mobile_begin_with: ['8', '9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'CG',
		alpha3: 'COG',
		country_code: '242',
		country_name: 'Congo',
		mobile_begin_with: ['0'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'CK',
		alpha3: 'COK',
		country_code: '682',
		country_name: 'Cook Islands',
		mobile_begin_with: ['5', '7'],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'CO',
		alpha3: 'COL',
		country_code: '57',
		country_name: 'Colombia',
		mobile_begin_with: ['3'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'CW',
		alpha3: 'CUW',
		country_code: '5999',
		country_name: 'Curaçao',
		mobile_begin_with: ['5', '6'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'KM',
		alpha3: 'COM',
		country_code: '269',
		country_name: 'Comoros',
		mobile_begin_with: ['3', '76'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'CV',
		alpha3: 'CPV',
		country_code: '238',
		country_name: 'Cape Verde',
		mobile_begin_with: ['5', '9'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'CR',
		alpha3: 'CRI',
		country_code: '506',
		country_name: 'Costa Rica',
		mobile_begin_with: ['5', '6', '7', '8'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'CU',
		alpha3: 'CUB',
		country_code: '53',
		country_name: 'Cuba',
		mobile_begin_with: ['5'],
		phone_number_lengths: [8]
	},
	// {alpha2: "CX", alpha3: "CXR", country_code: "61", country_name: "Christmas Island", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'KY',
		alpha3: 'CYM',
		country_code: '1',
		country_name: 'Cayman Islands',
		mobile_begin_with: ['345'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'CY',
		alpha3: 'CYP',
		country_code: '357',
		country_name: 'Cyprus',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'CZ',
		alpha3: 'CZE',
		country_code: '420',
		country_name: 'Czech Republic',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'DE',
		alpha3: 'DEU',
		country_code: '49',
		country_name: 'Germany',
		mobile_begin_with: ['15', '16', '17'],
		phone_number_lengths: [10, 11]
	},
	{
		alpha2: 'DJ',
		alpha3: 'DJI',
		country_code: '253',
		country_name: 'Djibouti',
		mobile_begin_with: ['77'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'DM',
		alpha3: 'DMA',
		country_code: '1',
		country_name: 'Dominica',
		mobile_begin_with: ['767'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'DK',
		alpha3: 'DNK',
		country_code: '45',
		country_name: 'Denmark',
		mobile_begin_with: [
			'2', '30', '31', '40', '41', '42', '50', '51', '52', '53', '60', '61', '71', '81', '91', '92', '93',
			'342', '344', '345', '346', '347', '348', '349', '356', '357', '359', '362',
			'365', '366', '389', '398', '431', '441', '462', '466', '468', '472', '474',
			'476', '478', '485', '486', '488', '489', '493', '494', '495', '496', '498',
			'499', '542', '543', '545', '551', '552', '556', '571', '572', '573', '574',
			'577', '579', '584', '586', '587', '589', '597', '598', '627', '629', '641',
			'649', '658', '662', '663', '664', '665', '667', '692', '693', '694', '697',
			'771', '772', '782', '783', '785', '786', '788', '789', '826', '827', '829'
		],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'DO',
		alpha3: 'DOM',
		country_code: '1',
		country_name: 'Dominican Republic',
		mobile_begin_with: ['809', '829', '849'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'DZ',
		alpha3: 'DZA',
		country_code: '213',
		country_name: 'Algeria',
		mobile_begin_with: ['5', '6', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'EC',
		alpha3: 'ECU',
		country_code: '593',
		country_name: 'Ecuador',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'EG',
		alpha3: 'EGY',
		country_code: '20',
		country_name: 'Egypt',
		mobile_begin_with: ['1'],
		phone_number_lengths: [10, 8]
	},
	{
		alpha2: 'ER',
		alpha3: 'ERI',
		country_code: '291',
		country_name: 'Eritrea',
		mobile_begin_with: ['1', '7', '8'],
		phone_number_lengths: [7]
	},
	// {alpha2: "EH", alpha3: "ESH", country_code: "212", country_name: "Western Sahara", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'ES',
		alpha3: 'ESP',
		country_code: '34',
		country_name: 'Spain',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'EE',
		alpha3: 'EST',
		country_code: '372',
		country_name: 'Estonia',
		mobile_begin_with: ['5', '81', '82', '83'],
		phone_number_lengths: [7, 8]
	},
	{
		alpha2: 'ET',
		alpha3: 'ETH',
		country_code: '251',
		country_name: 'Ethiopia',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'FI',
		alpha3: 'FIN',
		country_code: '358',
		country_name: 'Finland',
		mobile_begin_with: ['4', '5'],
		phone_number_lengths: [9, 10]
	},
	{
		alpha2: 'FJ',
		alpha3: 'FJI',
		country_code: '679',
		country_name: 'Fiji',
		mobile_begin_with: ['2', '7', '8', '9'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'FK',
		alpha3: 'FLK',
		country_code: '500',
		country_name: 'Falkland Islands (Malvinas)',
		mobile_begin_with: ['5', '6'],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'FR',
		alpha3: 'FRA',
		country_code: '33',
		country_name: 'France',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'FO',
		alpha3: 'FRO',
		country_code: '298',
		country_name: 'Faroe Islands',
		mobile_begin_with: [],
		phone_number_lengths: [6]
	},
	{
		alpha2: 'FM',
		alpha3: 'FSM',
		country_code: '691',
		country_name: 'Micronesia, Federated States Of',
		mobile_begin_with: [],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'GA',
		alpha3: 'GAB',
		country_code: '241',
		country_name: 'Gabon',
		mobile_begin_with: ['2', '3', '4', '5', '6', '7'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'GB',
		alpha3: 'GBR',
		country_code: '44',
		country_name: 'United Kingdom',
		mobile_begin_with: ['7'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'GE',
		alpha3: 'GEO',
		country_code: '995',
		country_name: 'Georgia',
		mobile_begin_with: ['5', '7'],
		phone_number_lengths: [9]
	},
	// {alpha2: "GG", alpha3: "GGY", country_code: "44", country_name: "Guernsey", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'GH',
		alpha3: 'GHA',
		country_code: '233',
		country_name: 'Ghana',
		mobile_begin_with: ['2', '5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'GI',
		alpha3: 'GIB',
		country_code: '350',
		country_name: 'Gibraltar',
		mobile_begin_with: ['5'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'GN',
		alpha3: 'GIN',
		country_code: '224',
		country_name: 'Guinea',
		mobile_begin_with: ['6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'GP',
		alpha3: 'GLP',
		country_code: '590',
		country_name: 'Guadeloupe',
		mobile_begin_with: ['690'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'GM',
		alpha3: 'GMB',
		country_code: '220',
		country_name: 'Gambia',
		mobile_begin_with: ['7', '9'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'GW',
		alpha3: 'GNB',
		country_code: '245',
		country_name: 'Guinea-Bissau',
		mobile_begin_with: ['5', '6', '7'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'GQ',
		alpha3: 'GNQ',
		country_code: '240',
		country_name: 'Equatorial Guinea',
		mobile_begin_with: ['222', '551'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'GR',
		alpha3: 'GRC',
		country_code: '30',
		country_name: 'Greece',
		mobile_begin_with: ['6'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'GD',
		alpha3: 'GRD',
		country_code: '1',
		country_name: 'Grenada',
		mobile_begin_with: ['473'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'GL',
		alpha3: 'GRL',
		country_code: '299',
		country_name: 'Greenland',
		mobile_begin_with: ['2', '4', '5'],
		phone_number_lengths: [6]
	},
	{
		alpha2: 'GT',
		alpha3: 'GTM',
		country_code: '502',
		country_name: 'Guatemala',
		mobile_begin_with: ['3', '4', '5'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'GF',
		alpha3: 'GUF',
		country_code: '594',
		country_name: 'French Guiana',
		mobile_begin_with: ['694'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'GU',
		alpha3: 'GUM',
		country_code: '1',
		country_name: 'Guam',
		mobile_begin_with: ['671'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'GY',
		alpha3: 'GUY',
		country_code: '592',
		country_name: 'Guyana',
		mobile_begin_with: ['6'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'HK',
		alpha3: 'HKG',
		country_code: '852',
		country_name: 'Hong Kong',
		mobile_begin_with: ['4', '5', '6', '70', '71', '72', '73', '81', '82', '83', '84', '85', '86', '87', '88', '89', '9'],
		phone_number_lengths: [8]
	},
	// {alpha2: "HM", alpha3: "HMD", country_code: "", country_name: "Heard and McDonald Islands", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'HN',
		alpha3: 'HND',
		country_code: '504',
		country_name: 'Honduras',
		mobile_begin_with: ['3', '7', '8', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'HR',
		alpha3: 'HRV',
		country_code: '385',
		country_name: 'Croatia',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8, 9]
	},
	{
		alpha2: 'HT',
		alpha3: 'HTI',
		country_code: '509',
		country_name: 'Haiti',
		mobile_begin_with: ['3', '4'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'HU',
		alpha3: 'HUN',
		country_code: '36',
		country_name: 'Hungary',
		mobile_begin_with: ['20', '30', '31', '50', '70'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'ID',
		alpha3: 'IDN',
		country_code: '62',
		country_name: 'Indonesia',
		mobile_begin_with: ['8'],
		phone_number_lengths: [9, 10, 11, 12]
	},
	// {alpha2: "IM", alpha3: "IMN", country_code: "44", country_name: "Isle of Man", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'IN',
		alpha3: 'IND',
		country_code: '91',
		country_name: 'India',
		mobile_begin_with: ['6', '7', '8', '9'],
		phone_number_lengths: [10]
	},
	// {alpha2: "IO", alpha3: "IOT", country_code: "246", country_name: "British Indian Ocean Territory", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'IE',
		alpha3: 'IRL',
		country_code: '353',
		country_name: 'Ireland',
		mobile_begin_with: ['82', '83', '84', '85', '86', '87', '88', '89'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'IR',
		alpha3: 'IRN',
		country_code: '98',
		country_name: 'Iran, Islamic Republic Of',
		mobile_begin_with: ['9'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'IQ',
		alpha3: 'IRQ',
		country_code: '964',
		country_name: 'Iraq',
		mobile_begin_with: ['7'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'IS',
		alpha3: 'ISL',
		country_code: '354',
		country_name: 'Iceland',
		mobile_begin_with: ['6', '7', '8'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'IL',
		alpha3: 'ISR',
		country_code: '972',
		country_name: 'Israel',
		mobile_begin_with: ['5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'IT',
		alpha3: 'ITA',
		country_code: '39',
		country_name: 'Italy',
		mobile_begin_with: ['3'],
		phone_number_lengths: [9, 10]
	},
	{
		alpha2: 'JM',
		alpha3: 'JAM',
		country_code: '1',
		country_name: 'Jamaica',
		mobile_begin_with: ['876'],
		phone_number_lengths: [10]
	},
	// {alpha2: "JE", alpha3: "JEY", country_code: "44", country_name: "Jersey", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'JO',
		alpha3: 'JOR',
		country_code: '962',
		country_name: 'Jordan',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'JP',
		alpha3: 'JPN',
		country_code: '81',
		country_name: 'Japan',
		mobile_begin_with: ['70', '80', '90'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'KZ',
		alpha3: 'KAZ',
		country_code: '7',
		country_name: 'Kazakhstan',
		mobile_begin_with: ['70', '74', '77'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'KE',
		alpha3: 'KEN',
		country_code: '254',
		country_name: 'Kenya',
		mobile_begin_with: ['7', '1'],
		phone_number_lengths: [8,9,10]
	},
	{
		alpha2: 'KG',
		alpha3: 'KGZ',
		country_code: '996',
		country_name: 'Kyrgyzstan',
		mobile_begin_with: ['20', '22', '31258', '312973', '5', '600', '7', '88', '912', '99'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'KH',
		alpha3: 'KHM',
		country_code: '855',
		country_name: 'Cambodia',
		mobile_begin_with: ['1', '6', '7', '8', '9'],
		phone_number_lengths: [8, 9]
	},
	{
		alpha2: 'KI',
		alpha3: 'KIR',
		country_code: '686',
		country_name: 'Kiribati',
		mobile_begin_with: ['9', '30'],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'KN',
		alpha3: 'KNA',
		country_code: '1',
		country_name: 'Saint Kitts And Nevis',
		mobile_begin_with: ['869'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'KR',
		alpha3: 'KOR',
		country_code: '82',
		country_name: 'Korea, Republic of',
		mobile_begin_with: ['1'],
		phone_number_lengths: [9, 10]
	},
	{
		alpha2: 'KW',
		alpha3: 'KWT',
		country_code: '965',
		country_name: 'Kuwait',
		mobile_begin_with: ['5', '6', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'LA',
		alpha3: 'LAO',
		country_code: '856',
		country_name: "Lao People's Democratic Republic",
		mobile_begin_with: ['20'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'LB',
		alpha3: 'LBN',
		country_code: '961',
		country_name: 'Lebanon',
		mobile_begin_with: ['3', '7', '8'],
		phone_number_lengths: [7, 8]
	},
	{
		alpha2: 'LR',
		alpha3: 'LBR',
		country_code: '231',
		country_name: 'Liberia',
		mobile_begin_with: ['4', '5', '6', '7'],
		phone_number_lengths: [7, 8]
	},
	{
		alpha2: 'LY',
		alpha3: 'LBY',
		country_code: '218',
		country_name: 'Libyan Arab Jamahiriya',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'LC',
		alpha3: 'LCA',
		country_code: '1',
		country_name: 'Saint Lucia',
		mobile_begin_with: ['758'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'LI',
		alpha3: 'LIE',
		country_code: '423',
		country_name: 'Liechtenstein',
		mobile_begin_with: ['7'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'LK',
		alpha3: 'LKA',
		country_code: '94',
		country_name: 'Sri Lanka',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'LS',
		alpha3: 'LSO',
		country_code: '266',
		country_name: 'Lesotho',
		mobile_begin_with: ['5', '6'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'LT',
		alpha3: 'LTU',
		country_code: '370',
		country_name: 'Lithuania',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'LU',
		alpha3: 'LUX',
		country_code: '352',
		country_name: 'Luxembourg',
		mobile_begin_with: ['6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'LV',
		alpha3: 'LVA',
		country_code: '371',
		country_name: 'Latvia',
		mobile_begin_with: ['2'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MO',
		alpha3: 'MAC',
		country_code: '853',
		country_name: 'Macao',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	// {alpha2: "MF", alpha3: "MAF", country_code: "590", country_name: "Saint Martin", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'MA',
		alpha3: 'MAR',
		country_code: '212',
		country_name: 'Morocco',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'MC',
		alpha3: 'MCO',
		country_code: '377',
		country_name: 'Monaco',
		mobile_begin_with: ['4', '6'],
		phone_number_lengths: [8, 9]
	},
	{
		alpha2: 'MD',
		alpha3: 'MDA',
		country_code: '373',
		country_name: 'Moldova, Republic of',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MG',
		alpha3: 'MDG',
		country_code: '261',
		country_name: 'Madagascar',
		mobile_begin_with: ['3'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'MV',
		alpha3: 'MDV',
		country_code: '960',
		country_name: 'Maldives',
		mobile_begin_with: ['7', '9'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'MX',
		alpha3: 'MEX',
		country_code: '52',
		country_name: 'Mexico',
		mobile_begin_with: [''],
		phone_number_lengths: [10, 11]
	},
	{
		alpha2: 'MH',
		alpha3: 'MHL',
		country_code: '692',
		country_name: 'Marshall Islands',
		mobile_begin_with: [],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'MK',
		alpha3: 'MKD',
		country_code: '389',
		country_name: 'Macedonia, the Former Yugoslav Republic Of',
		mobile_begin_with: ['7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'ML',
		alpha3: 'MLI',
		country_code: '223',
		country_name: 'Mali',
		mobile_begin_with: ['6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MT',
		alpha3: 'MLT',
		country_code: '356',
		country_name: 'Malta',
		mobile_begin_with: ['7', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MM',
		alpha3: 'MMR',
		country_code: '95',
		country_name: 'Myanmar',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8, 9, 10]
	},
	{
		alpha2: 'ME',
		alpha3: 'MNE',
		country_code: '382',
		country_name: 'Montenegro',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MN',
		alpha3: 'MNG',
		country_code: '976',
		country_name: 'Mongolia',
		mobile_begin_with: ['5', '8', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MP',
		alpha3: 'MNP',
		country_code: '1',
		country_name: 'Northern Mariana Islands',
		mobile_begin_with: ['670'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'MZ',
		alpha3: 'MOZ',
		country_code: '258',
		country_name: 'Mozambique',
		mobile_begin_with: ['8'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'MR',
		alpha3: 'MRT',
		country_code: '222',
		country_name: 'Mauritania',
		mobile_begin_with: [],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MS',
		alpha3: 'MSR',
		country_code: '1',
		country_name: 'Montserrat',
		mobile_begin_with: ['664'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'MQ',
		alpha3: 'MTQ',
		country_code: '596',
		country_name: 'Martinique',
		mobile_begin_with: ['696'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'MU',
		alpha3: 'MUS',
		country_code: '230',
		country_name: 'Mauritius',
		mobile_begin_with: ['5'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'MW',
		alpha3: 'MWI',
		country_code: '265',
		country_name: 'Malawi',
		mobile_begin_with: ['77', '88', '99'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'MY',
		alpha3: 'MYS',
		country_code: '60',
		country_name: 'Malaysia',
		mobile_begin_with: ['1', '6'],
		phone_number_lengths: [9, 10, 8]
	},
	{
		alpha2: 'YT',
		alpha3: 'MYT',
		country_code: '262',
		country_name: 'Mayotte',
		mobile_begin_with: ['639'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'NA',
		alpha3: 'NAM',
		country_code: '264',
		country_name: 'Namibia',
		mobile_begin_with: ['60', '81', '82', '85'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'NC',
		alpha3: 'NCL',
		country_code: '687',
		country_name: 'New Caledonia',
		mobile_begin_with: ['7', '8', '9'],
		phone_number_lengths: [6]
	},
	{
		alpha2: 'NE',
		alpha3: 'NER',
		country_code: '227',
		country_name: 'Niger',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'NF',
		alpha3: 'NFK',
		country_code: '672',
		country_name: 'Norfolk Island',
		mobile_begin_with: ['5', '8'],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'NG',
		alpha3: 'NGA',
		country_code: '234',
		country_name: 'Nigeria',
		mobile_begin_with: ['70', '80', '81', '90', '91'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'NI',
		alpha3: 'NIC',
		country_code: '505',
		country_name: 'Nicaragua',
		mobile_begin_with: ['8'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'NU',
		alpha3: 'NIU',
		country_code: '683',
		country_name: 'Niue',
		mobile_begin_with: [],
		phone_number_lengths: [4]
	},
	{
		alpha2: 'NL',
		alpha3: 'NLD',
		country_code: '31',
		country_name: 'Netherlands',
		mobile_begin_with: ['6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'NO',
		alpha3: 'NOR',
		country_code: '47',
		country_name: 'Norway',
		mobile_begin_with: ['4', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'NP',
		alpha3: 'NPL',
		country_code: '977',
		country_name: 'Nepal',
		mobile_begin_with: ['97', '98'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'NR',
		alpha3: 'NRU',
		country_code: '674',
		country_name: 'Nauru',
		mobile_begin_with: ['555'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'NZ',
		alpha3: 'NZL',
		country_code: '64',
		country_name: 'New Zealand',
		mobile_begin_with: ['2'],
		phone_number_lengths: [8, 9, 10]
	},
	{
		alpha2: 'OM',
		alpha3: 'OMN',
		country_code: '968',
		country_name: 'Oman',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'PK',
		alpha3: 'PAK',
		country_code: '92',
		country_name: 'Pakistan',
		mobile_begin_with: ['3'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'PA',
		alpha3: 'PAN',
		country_code: '507',
		country_name: 'Panama',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	// {alpha2: "PN", alpha3: "PCN", country_code: "", country_name: "Pitcairn", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'PE',
		alpha3: 'PER',
		country_code: '51',
		country_name: 'Peru',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'PH',
		alpha3: 'PHL',
		country_code: '63',
		country_name: 'Philippines',
		mobile_begin_with: ['9'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'PW',
		alpha3: 'PLW',
		country_code: '680',
		country_name: 'Palau',
		mobile_begin_with: [],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'PG',
		alpha3: 'PNG',
		country_code: '675',
		country_name: 'Papua New Guinea',
		mobile_begin_with: ['7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'PL',
		alpha3: 'POL',
		country_code: '48',
		country_name: 'Poland',
		mobile_begin_with: ['4', '5', '6', '7', '8'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'PR',
		alpha3: 'PRI',
		country_code: '1',
		country_name: 'Puerto Rico',
		mobile_begin_with: ['787', '939'],
		phone_number_lengths: [10]
	},
	// {alpha2: "KP", alpha3: "PRK", country_code: "850", country_name: "Korea, Democratic People's Republic Of", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'PT',
		alpha3: 'PRT',
		country_code: '351',
		country_name: 'Portugal',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'PY',
		alpha3: 'PRY',
		country_code: '595',
		country_name: 'Paraguay',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'PS',
		alpha3: 'PSE',
		country_code: '970',
		country_name: 'Palestinian Territory, Occupied',
		mobile_begin_with: ['5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'PF',
		alpha3: 'PYF',
		country_code: '689',
		country_name: 'French Polynesia',
		mobile_begin_with: ['8'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'QA',
		alpha3: 'QAT',
		country_code: '974',
		country_name: 'Qatar',
		mobile_begin_with: ['3', '5', '6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'RE',
		alpha3: 'REU',
		country_code: '262',
		country_name: 'Réunion',
		mobile_begin_with: ['692', '693'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'RO',
		alpha3: 'ROU',
		country_code: '40',
		country_name: 'Romania',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'RU',
		alpha3: 'RUS',
		country_code: '7',
		country_name: 'Russian Federation',
		mobile_begin_with: ['9', '495', '498', '499', '835'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'RW',
		alpha3: 'RWA',
		country_code: '250',
		country_name: 'Rwanda',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SA',
		alpha3: 'SAU',
		country_code: '966',
		country_name: 'Saudi Arabia',
		mobile_begin_with: ['5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SD',
		alpha3: 'SDN',
		country_code: '249',
		country_name: 'Sudan',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SS',
		alpha3: 'SSD',
		country_code: '211',
		country_name: 'South Sudan',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SN',
		alpha3: 'SEN',
		country_code: '221',
		country_name: 'Senegal',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SG',
		alpha3: 'SGP',
		country_code: '65',
		country_name: 'Singapore',
		mobile_begin_with: ['8', '9'],
		phone_number_lengths: [8]
	},
	// {alpha2: "GS", alpha3: "SGS", country_code: "500", country_name: "South Georgia and the South Sandwich Islands", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'SH',
		alpha3: 'SHN',
		country_code: '290',
		country_name: 'Saint Helena',
		mobile_begin_with: [],
		phone_number_lengths: [4]
	},
	{
		alpha2: 'SJ',
		alpha3: 'SJM',
		country_code: '47',
		country_name: 'Svalbard And Jan Mayen',
		mobile_begin_with: ['79'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'SB',
		alpha3: 'SLB',
		country_code: '677',
		country_name: 'Solomon Islands',
		mobile_begin_with: ['7', '8'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'SL',
		alpha3: 'SLE',
		country_code: '232',
		country_name: 'Sierra Leone',
		mobile_begin_with: ['21', '25', '30', '33', '34', '40', '44', '50', '55', '76', '77', '78', '79', '88'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'SV',
		alpha3: 'SLV',
		country_code: '503',
		country_name: 'El Salvador',
		mobile_begin_with: ['7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'SM',
		alpha3: 'SMR',
		country_code: '378',
		country_name: 'San Marino',
		mobile_begin_with: ['3', '6'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'SO',
		alpha3: 'SOM',
		country_code: '252',
		country_name: 'Somalia',
		mobile_begin_with: ['61', '62', '63', '65', '66', '68', '69', '71', '90'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SX',
		alpha3: 'SXM',
		country_code: '1',
		country_name: 'Sint Maarten',
		mobile_begin_with: ['721'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'PM',
		alpha3: 'SPM',
		country_code: '508',
		country_name: 'Saint Pierre And Miquelon',
		mobile_begin_with: ['55', '41'],
		phone_number_lengths: [6]
	},
	{
		alpha2: 'RS',
		alpha3: 'SRB',
		country_code: '381',
		country_name: 'Serbia',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8, 9]
	},
	{
		alpha2: 'ST',
		alpha3: 'STP',
		country_code: '239',
		country_name: 'Sao Tome and Principe',
		mobile_begin_with: ['98', '99'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'SR',
		alpha3: 'SUR',
		country_code: '597',
		country_name: 'Suriname',
		mobile_begin_with: ['6', '7', '8'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'SK',
		alpha3: 'SVK',
		country_code: '421',
		country_name: 'Slovakia',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SI',
		alpha3: 'SVN',
		country_code: '386',
		country_name: 'Slovenia',
		mobile_begin_with: ['3', '4', '5', '6', '7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'SE',
		alpha3: 'SWE',
		country_code: '46',
		country_name: 'Sweden',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'SZ',
		alpha3: 'SWZ',
		country_code: '268',
		country_name: 'Swaziland',
		mobile_begin_with: ['76', '77', '78', '79'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'SC',
		alpha3: 'SYC',
		country_code: '248',
		country_name: 'Seychelles',
		mobile_begin_with: ['2'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'SY',
		alpha3: 'SYR',
		country_code: '963',
		country_name: 'Syrian Arab Republic',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	// http://www.howtocallabroad.com/turks-caicos/
	{
		alpha2: 'TC',
		alpha3: 'TCA',
		country_code: '1',
		country_name: 'Turks and Caicos Islands',
		mobile_begin_with: ['6492', '6493', '6494'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'TD',
		alpha3: 'TCD',
		country_code: '235',
		country_name: 'Chad',
		mobile_begin_with: ['6', '7', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'TG',
		alpha3: 'TGO',
		country_code: '228',
		country_name: 'Togo',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'TH',
		alpha3: 'THA',
		country_code: '66',
		country_name: 'Thailand',
		mobile_begin_with: ['6', '8', '9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'TJ',
		alpha3: 'TJK',
		country_code: '992',
		country_name: 'Tajikistan',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'TK',
		alpha3: 'TKL',
		country_code: '690',
		country_name: 'Tokelau',
		mobile_begin_with: [],
		phone_number_lengths: [4]
	},
	{
		alpha2: 'TM',
		alpha3: 'TKM',
		country_code: '993',
		country_name: 'Turkmenistan',
		mobile_begin_with: ['6'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'TL',
		alpha3: 'TLS',
		country_code: '670',
		country_name: 'Timor-Leste',
		mobile_begin_with: ['7'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'TO',
		alpha3: 'TON',
		country_code: '676',
		country_name: 'Tonga',
		mobile_begin_with: [],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'TT',
		alpha3: 'TTO',
		country_code: '1',
		country_name: 'Trinidad and Tobago',
		mobile_begin_with: ['868'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'TN',
		alpha3: 'TUN',
		country_code: '216',
		country_name: 'Tunisia',
		mobile_begin_with: ['2', '4', '5', '9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'TR',
		alpha3: 'TUR',
		country_code: '90',
		country_name: 'Turkey',
		mobile_begin_with: ['5'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'TV',
		alpha3: 'TUV',
		country_code: '688',
		country_name: 'Tuvalu',
		mobile_begin_with: [],
		phone_number_lengths: [5]
	},
	{
		alpha2: 'TW',
		alpha3: 'TWN',
		country_code: '886',
		country_name: 'Taiwan',
		mobile_begin_with: ['9'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'TZ',
		alpha3: 'TZA',
		country_code: '255',
		country_name: 'Tanzania, United Republic of',
		mobile_begin_with: ['7', '6'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'UG',
		alpha3: 'UGA',
		country_code: '256',
		country_name: 'Uganda',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'UA',
		alpha3: 'UKR',
		country_code: '380',
		country_name: 'Ukraine',
		mobile_begin_with: ['39', '50', '63', '66', '67', '68', '73', '9'],
		phone_number_lengths: [9]
	},
	// {alpha2: "UM", alpha3: "UMI", country_code: "", country_name: "United States Minor Outlying Islands", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'UY',
		alpha3: 'URY',
		country_code: '598',
		country_name: 'Uruguay',
		mobile_begin_with: ['9'],
		phone_number_lengths: [8]
	},
	{
		alpha2: 'UZ',
		alpha3: 'UZB',
		country_code: '998',
		country_name: 'Uzbekistan',
		mobile_begin_with: ['9', '88', '33'],
		phone_number_lengths: [9]
	},
	// {alpha2: "VA", alpha3: "VAT", country_code: "39", country_name: "Holy See (Vatican City State)", mobile_begin_with: [], phone_number_lengths: []},
	{
		alpha2: 'VC',
		alpha3: 'VCT',
		country_code: '1',
		country_name: 'Saint Vincent And The Grenedines',
		mobile_begin_with: ['784'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'VE',
		alpha3: 'VEN',
		country_code: '58',
		country_name: 'Venezuela, Bolivarian Republic of',
		mobile_begin_with: ['4'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'VG',
		alpha3: 'VGB',
		country_code: '1',
		country_name: 'Virgin Islands, British',
		mobile_begin_with: ['284'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'VI',
		alpha3: 'VIR',
		country_code: '1',
		country_name: 'Virgin Islands, U.S.',
		mobile_begin_with: ['340'],
		phone_number_lengths: [10]
	},
	{
		alpha2: 'VN',
		alpha3: 'VNM',
		country_code: '84',
		country_name: 'Viet Nam',
		mobile_begin_with: ['8', '9', '3', '7', '5'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'VU',
		alpha3: 'VUT',
		country_code: '678',
		country_name: 'Vanuatu',
		mobile_begin_with: ['5', '7'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'WF',
		alpha3: 'WLF',
		country_code: '681',
		country_name: 'Wallis and Futuna',
		mobile_begin_with: [],
		phone_number_lengths: [6]
	},
	{
		alpha2: 'WS',
		alpha3: 'WSM',
		country_code: '685',
		country_name: 'Samoa',
		mobile_begin_with: ['7'],
		phone_number_lengths: [7]
	},
	{
		alpha2: 'YE',
		alpha3: 'YEM',
		country_code: '967',
		country_name: 'Yemen',
		mobile_begin_with: ['7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'ZA',
		alpha3: 'ZAF',
		country_code: '27',
		country_name: 'South Africa',
		mobile_begin_with: ['1', '2', '3', '4', '5', '6', '7', '8'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'ZM',
		alpha3: 'ZMB',
		country_code: '260',
		country_name: 'Zambia',
		mobile_begin_with: ['9', '7'],
		phone_number_lengths: [9]
	},
	{
		alpha2: 'ZW',
		alpha3: 'ZWE',
		country_code: '263',
		country_name: 'Zimbabwe',
		mobile_begin_with: ['71', '73', '77', '78'],
		phone_number_lengths: [9]
	}
];
export {countries,CountriesLength}